var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button secondary small pl-2 pr-2",attrs:{"disabled":_vm.disabled || _vm.isLoading},on:{"click":_vm.download}},[_c('Icon',{staticClass:"ml-0",attrs:{"icon":"download","size":"14"}}),_vm._v(" Download Report ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }